import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column } from '~/commonComponents/Column';
import { EmptyWorkedWithProfessionalCopy } from '~/components/ProfessionalsHub/Constants';

export const NoWorkedWith = () => {
  return (
    <Column alignItems="center">
      <EmptyWorkedWithProfessionalCopy.Icon size={136} />

      <Typography as="span" bold color={colors.neutral[500]} size="heading_4" style={{ marginTop: 18 }}>
        {EmptyWorkedWithProfessionalCopy.title}
      </Typography>
      <Typography as="span" color={colors.neutral[500]} textAlign="center" style={{ marginTop: 18, width: 392 }}>
        {EmptyWorkedWithProfessionalCopy.description}
      </Typography>
    </Column>
  );
};
